module.exports = __webpack_public_path__ + "assets/img/evalute-success-icon.323c3068.png";